import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../../../../../console/src/plugins/i18n'

const base = 'import_entities'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
});
AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
});
AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
});

AdminSidebar.pushItem({
  id: `${base}`,
  order: 150,
  header: $vm => $vm.$t(`general.menu_management`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-vcard',
  permission($vm) {
    return $vm.$allows('users.index') || $vm.$allows('users.serve')
  },
})

messageGroups.push(base)
